import React from 'react';

import styles from './CoursePauseRequestedRequestsTableHeader.module.scss';
import TableCell from 'components/TableCell';
import TableHead from 'components/TableHead';
import TableRow from 'components/TableRow';

function CoursePauseRequestedRequestsTableHeader() {
  return (
    <TableHead className={styles.root}>
      <TableRow>
        <TableCell className={styles.heading}>Learner Email</TableCell>
        <TableCell className={styles.heading}>Requested Date</TableCell>
        <TableCell className={styles.heading}>Pause Start Date</TableCell>
        <TableCell className={styles.heading}>
          Preferred Pause Duration
        </TableCell>
        <TableCell className={styles.heading}>From Module</TableCell>
        <TableCell className={styles.heading}>To Module</TableCell>
        <TableCell className={styles.heading}>Streak Enabled</TableCell>
        <TableCell className={styles.heading}>Action</TableCell>
      </TableRow>
    </TableHead>
  );
}

export default CoursePauseRequestedRequestsTableHeader;
